import { DOCUMENT } from "@angular/common";
import {
    Component,
    Inject,
    ElementRef,
    OnInit,
    Renderer2,
    AfterViewInit,
    HostListener,
} from "@angular/core";
import { Router } from "@angular/router";
import { ConfigService } from "src/app/config/config.service";
import { AuthService } from "src/app/services/auth.service";
import { LanguageService } from "src/app/core/service/language.service";
import { UnsubscribeOnDestroyAdapter } from "src/app/shared/UnsubscribeOnDestroyAdapter";
import { ROUTES } from "../sidebar/sidebar-items";
import { environment } from "src/environments/environment";
import { UserRightsService } from 'src/app/services/userRights.service';
const document: any = window.document;
import { headerNavItems } from './header-nav-items';

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
})
export class HeaderComponent
    extends UnsubscribeOnDestroyAdapter
    implements OnInit, AfterViewInit {
    public config: any = {};
    userData: any = {};
    userImg: string;
    public isCollapsed = true;
    public isNavbarToggled = false;
    //nv
    public sidebarItems: any[];
    listMaxHeight: string;
    listMaxWidth: string;
    userFullName: string;
    userType: string;
    headerHeight = 60;
    currentRoute: string;
    routerObj = null;
    menuIcon = "radio_button_checked";
    is_mobile = environment.is_mobile;
    windowWidth: number;

    // Add these for dynamic navigation
    navItems: any[] = [];
    userRights: string[] = [];
    navMenuRefs: any[] = [];
    homePage: string;
    isNavbarCollapsed = true;
    flagvalue;
    countryName;
    langStoreValue: string;
    defaultFlag: string;
    isOpenSidebar: boolean;
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        public elementRef: ElementRef,
        private configService: ConfigService,
        private authService: AuthService,
        private router: Router,
        public languageService: LanguageService,
        private userRightsService: UserRightsService
    ) {
        super();
    }
    listLang = [
        { text: "English", flag: "assets/images/flags/us.jpg", lang: "en" },
        { text: "Urdu", flag: "assets/images/flags/pakistan.png", lang: "ur" },
    ];

    ngOnInit() {

        this.config = this.configService.configData;
        this.userImg = this.authService.currentUserValue.user.photo;
        this.userData = JSON.parse(localStorage.getItem("user"));

        this.homePage = "dashboard/dashboard1";

        if (this.authService.currentUserValue) {

            this.userFullName = this.authService.currentUserValue.user.name;
            this.userImg = this.authService.currentUserValue.user.photo;
            this.userType = "Admin";
            this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
        }
        this.langStoreValue = localStorage.getItem("lang");

        const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
        this.countryName = val.map((element) => element.text);
        if (val.length === 0) {
            if (this.flagvalue === undefined) {
                this.defaultFlag = "assets/images/flags/us.jpg";
            }
        } else {
            this.flagvalue = val.map((element) => element.flag);
        }
        this.windowWidth = window.innerWidth;
        this.is_mobile = this.windowWidth <= 991;

        // Get permissions from localStorage as array of objects
        const permissions = this.getUserPermissions();

        console.log(permissions);
        // If user is super admin, show all nav items
        // const isSuperAdmin = this.userData && this.userData.user && (this.userData.user.role === 'super_admin');
        // if (isSuperAdmin) {
        this.navItems = headerNavItems;
        // } else {
        //     // Filter nav items based on permissions
        //     this.navItems = this.filterHeaderNavItemsByPermission(headerNavItems, permissions);
        // }

        console.log("Filtered nav items:", this.navItems);
    }

    private filterHeaderNavItemsByPermission(navItems: any[], userPermissions: any[]): any[] {
        return navItems
            .map(section => {
                // Handle standalone items (not a menu group)
                if (!section.menu) {
                    if (!section.rightKey) return null;
                    const hasPermission = userPermissions.some(permission =>
                        permission.screen_name === section.rightKey &&
                        permission.action_name === section.action
                    );
                    return hasPermission ? section : null;
                }

                // Menu is a flat array, not array of groups
                const filteredMenu = section.menu.filter(item =>
                    item.rightKey && userPermissions.some(permission =>
                        permission.screen_name === item.rightKey &&
                        permission.action_name === item.action
                    )
                );

                return filteredMenu.length ? { ...section, menu: filteredMenu } : null;
            })
            .filter(section => !!section);
    }


    getUserPermissions(): any[] {
        // Get from localStorage or AuthService
        const userPermissions = JSON.parse(localStorage.getItem('permissions') || '[]');
        return Array.isArray(userPermissions) ? userPermissions : [];
    }




    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.windowWidth = event.target.innerWidth;
        this.is_mobile = this.windowWidth <= 991 ? true : false;

        // Do something with the new width, such as adjusting layout or styles
    }
    onGlobalClick(event): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.renderer.removeClass(this.document.body, "overlay-open");
        }
    }
    callToggleMenu(event: any, length: any) {
        if (length > 0) {
            const parentElement = event.target.closest("li");
            const activeClass = parentElement.classList.contains("active");

            if (activeClass) {
                this.renderer.removeClass(parentElement, "active");
            } else {
                this.renderer.addClass(parentElement, "active");
            }
        }
    }
    ngAfterViewInit() {
        // set theme on startup
        if (localStorage.getItem("theme")) {
            this.renderer.removeClass(
                this.document.body,
                this.config.layout.variant
            );
            this.renderer.addClass(
                this.document.body,
                localStorage.getItem("theme")
            );
        } else {
            this.renderer.addClass(
                this.document.body,
                this.config.layout.variant
            );
        }

        if (localStorage.getItem("menuOption")) {
            this.renderer.addClass(
                this.document.body,
                localStorage.getItem("menuOption")
            );
        } else {
            this.renderer.addClass(
                this.document.body,
                "menu_" + this.config.layout.sidebar.backgroundColor
            );
        }

        if (localStorage.getItem("choose_logoheader")) {
            this.renderer.addClass(
                this.document.body,
                localStorage.getItem("choose_logoheader")
            );
        } else {
            this.renderer.addClass(
                this.document.body,
                "logo-" + this.config.layout.logo_bg_color
            );
        }

        if (localStorage.getItem("sidebar_status")) {
            if (localStorage.getItem("sidebar_status") === "close") {
                this.renderer.addClass(this.document.body, "side-closed");
                this.renderer.addClass(this.document.body, "submenu-closed");
            } else {
                this.renderer.removeClass(this.document.body, "side-closed");
                this.renderer.removeClass(this.document.body, "submenu-closed");
            }
        } else {
            if (this.config.layout.sidebar.collapsed === true) {
                this.renderer.addClass(this.document.body, "side-closed");
                this.renderer.addClass(this.document.body, "submenu-closed");
            }
        }
    }
    callFullscreen() {
        if (
            !document.fullscreenElement &&
            !document.mozFullScreenElement &&
            !document.webkitFullscreenElement &&
            !document.msFullscreenElement
        ) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) {
                document.documentElement.msRequestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    }
    setLanguage(text: string, lang: string, flag: string) {
        this.countryName = text;
        this.flagvalue = flag;
        this.langStoreValue = lang;
        this.languageService.setLanguage(lang);
    }
    mobileMenuSidebarOpen(event: any, className: string) {
        const hasClass = event.target.classList.contains(className);
        if (hasClass) {
            this.renderer.removeClass(this.document.body, className);
        } else {
            this.renderer.addClass(this.document.body, className);
        }

        const hasClass2 = this.document.body.classList.contains("side-closed");
        if (hasClass2) {
            // this.renderer.removeClass(this.document.body, "side-closed");
            this.renderer.removeClass(this.document.body, "submenu-closed");
        } else {
            // this.renderer.addClass(this.document.body, "side-closed");
            this.renderer.addClass(this.document.body, "submenu-closed");
        }
    }
    callSidemenuCollapse() {
        const hasClass = this.document.body.classList.contains("side-closed");
        if (hasClass) {
            this.renderer.removeClass(this.document.body, "side-closed");
            this.renderer.removeClass(this.document.body, "submenu-closed");
        } else {
            this.renderer.addClass(this.document.body, "side-closed");
            this.renderer.addClass(this.document.body, "submenu-closed");
        }
    }
    logout() {
        this.subs.sink = this.authService.logout().subscribe((res) => {
            if (!res.success) {
                localStorage.clear();

                this.router.navigate(["/authentication/signin"]);
            }
        });
    }
    closeNavbar() {
        this.isNavbarToggled = false;
        this.callSidemenuCollapse(); // Close the sidebar as well
    }
}
